export default __webpack_public_path__ + "static/bro-af15b3c144ad04b2e13b13d099b4550e.webp";